exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sources-list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\nul {\n  max-height: 100px;\n  overflow: auto;\n}\nul li a {\n  color: blue;\n  cursor: pointer;\n}\ntextarea {\n  height: 50px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/context/container/container.component.less
// module id = ../../../../../src/app/packages/context/container/container.component.less
// module chunks = main